import { Component, OnInit } from '@angular/core';
import { ButtonComponent } from '@components/button/button.component';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogPopUpComponent } from '@components/dialog-pop-up/dialog-pop-up.component';
import { LoggerService } from '@services/logger.service';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { PracticesService } from '@services/practices.service';
import { ToastrService } from 'ngx-toastr';
import { Registry } from '@/registry.service';
import { PracticeAccessoryModel } from '@/models/practice-accessory-model';

@Component({
  selector: 'app-button-practice-accessory-delete',
  templateUrl: '../button.component.html',
  styleUrls: ['../button.component.scss'],
})
export class ButtonDeletePracticeAccessoryComponent extends ButtonComponent implements OnInit {
  private accessory: PracticeAccessoryModel;
  private rowData: any;
  faIcon = faTrashCan;

  constructor(
    protected router: Router,
    public dialog: MatDialog,
    private practiceService: PracticesService,
    protected toastr: ToastrService,
  ) {
    super(router, toastr);

    this.color = 'danger';
    this.additionalClass = 'py-0.5 px-2.5';
    this.showIcon = true;
    this.smallBtn = true;
  }

  ngOnInit() {
    this.accessory = <PracticeAccessoryModel>this.rowData;
  }

  public actionClick(): void {
    let dialogRef = this.dialog.open(DialogPopUpComponent, {
      width: 'auto',
      panelClass: 'custom-modalbox',
    });

    this.setupPopup(dialogRef);

    dialogRef.afterClosed().subscribe((deleteSeller) => {
      if (deleteSeller) {
        this.practiceService.deleteAccessory(this.accessory.id).subscribe({
          next: () => {
            this.toastr.success('Accessorio cancellato correttamente!');

            Registry.getInstance().get('PracticeDetailsComponent').refreshAccessories();
          },
          error: (error) => {
            LoggerService.error('deleteAccessory failed!');
            LoggerService.error(error);

            this.toastr.error(`Errore durante la cancellazione dell'Accessorio.`);
          },
          complete: () => {
            LoggerService.log('Request done');
          },
        });
      }
    });
  }

  private setupPopup(dialogRef: MatDialogRef<DialogPopUpComponent>) {
    dialogRef.componentInstance.title = 'Confermi di voler cancellare questo Accessorio?';
    dialogRef.componentInstance.content =
      "Attenzione una volta cancellata l'Accessorio non sarà più possibile recuperarlo.";
    dialogRef.componentInstance.firstCTA = 'Si cancella';
    dialogRef.componentInstance.secondCTA = 'Annulla operazione';
    dialogRef.componentInstance.closeResultFirst = true;
    dialogRef.componentInstance.closeResultSecond = false;
  }
}
